import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./index.css";

import { installWebAuthnArrayBufferShim } from "./utils/webauthn/normalizeCredentials";
import App from "./App.tsx";

function ensureResponsiveViewport() {
  const desired = "width=device-width, initial-scale=1, viewport-fit=cover";
  let meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "viewport";
    document.head.appendChild(meta);
  }
  if (meta.content !== desired) {
    meta.content = desired;
  }
}

async function initializeApp() {
  // Auth0's hosted Universal Login template may ship a <meta viewport> that
  // forces a desktop-width layout on mobile devices. Override it so our
  // responsive Tailwind breakpoints behave correctly.
  ensureResponsiveViewport();

  // LastPass (and similarly-buggy passkey extensions) return Uint8Array from
  // navigator.credentials.create/.get; Auth0's ACUL SDK strictly requires
  // ArrayBuffer and throws TypeError otherwise. Install a shim before any
  // screen renders.
  installWebAuthnArrayBufferShim();

  // Load Geist font from Google Fonts
  const fontLink = document.createElement("link");
  fontLink.rel = "stylesheet";
  fontLink.href =
    "https://fonts.googleapis.com/css2?family=Geist:wght@300;400;500;600;700&display=swap";
  document.head.appendChild(fontLink);

  const rootElement = document.createElement("div");
  rootElement.id = "root";

  document.body.appendChild(rootElement);

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

initializeApp();
